import { render } from "./Assistente.vue?vue&type=template&id=71086058&scoped=true"
import script from "./Assistente.vue?vue&type=script&lang=js"
export * from "./Assistente.vue?vue&type=script&lang=js"

import "./Assistente.vue?vue&type=style&index=0&id=71086058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71086058"]])

export default __exports__